/**
 * Created by JIA on 2020/7/13.
 */
import React from "react";
import { Text } from "react-native";
import PropTypes from "prop-types";
import { GetSentenceStyleBySentenceCommand } from "../../utils/MarkTextHelper";

const TranslationText = props => {
    const sentenceStyle = GetSentenceStyleBySentenceCommand(props.sentenceCommand, props.sentenceCommandSetting);
    return (
        <Text allowFontScaling={true} {...props} style={{ ...sentenceStyle, fontSize: 15, ...props.style }}>
            {props.children}
        </Text>
    );
};

TranslationText.propTypes = {
    sentenceCommand: PropTypes.number,
    sentenceCommandSetting: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    style: PropTypes.object,
};

TranslationText.defaultProps = {
    sentenceCommand: 1,
    sentenceCommandSetting: null,
    style: {},
};

export default TranslationText;
